import {
  AfterViewInit, ChangeDetectorRef, Component, computed, HostBinding, inject, input,
  OnDestroy, OnInit, output, PLATFORM_ID, viewChild
} from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { isPlatformServer, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { SdTitleComponent } from '../title/title.component';
import { BaseFormErrorTranslateService } from '../forms/form-common-error/base-form-error-translate.service';
import { ErrorTranslateService } from '../forms/error-translate-service';
import { ImageRatioEnum } from '../../_enums/image-ratio.enum';
import { ISdFormComponentItem } from '../forms/form-component-interface.model';
import { SdBannerComponent } from '../medias/banner/banner.component';
import { SdFormSelectComponent } from '../forms/form-select/form-select.component';
import { SdIconComponent } from '../icons/icon/icon.component';
import { SdLibConfig } from '../../sd-lib-config';
import { SdLinkComponent } from '../links/link/link.component';
import { SdListComponent } from '../lists/list/list.component';
import { DeviceService } from '../../_services/device.service';
import { IProductCustomer } from '../product-customer/product-customer.interface';
import { SdConvertedPriceComponent } from '../converted-price/converted-price.component';

@Component({
  selector: 'sd-navigation-product-card',
  templateUrl: './navigation-product-card.component.html',
  standalone: true,
  imports: [
    SdBannerComponent,
    SdTitleComponent,
    NgClass,
    SdIconComponent,
    SdLinkComponent,
    SdFormSelectComponent,
    SdListComponent,
    TranslateModule,
    SdConvertedPriceComponent
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdNavigationProductCardComponent implements OnInit, AfterViewInit, OnDestroy {
  indexFollow = input(true);
  imageRatio = input<ImageRatioEnum>(ImageRatioEnum.r4_3);
  productInfo = input<IProductCustomer>();
  quantityDisabled = input(false);
  isReadOnly = input(true);
  isSimplified = input(false);
  titleLevel = input(4);
  class = input('');

  updatedSelectedValue = computed(() => this.productInfo()?.quantity ?? 1);

  clicked = output<string>();
  quantity = output<number>();
  openRecommendedPriceModal = output<void>();

  quantitySelector = viewChild<SdFormSelectComponent<number>>('quantitySelector');

  private readonly sdLibConfig = inject(SdLibConfig);
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly deviceService = inject(DeviceService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly platformId = inject(PLATFORM_ID);

  @HostBinding('class')
  get hostClasses(): string {
    return this.computedHostClasses();
  }

  isSSR!: boolean;
  imageHasBorder: boolean;
  itemQty: ISdFormComponentItem[];
  quantityForm: UntypedFormGroup;
  subscription = new Subscription();
  isMobile$: boolean;
  imageRatioEnum = ImageRatioEnum;
  imageRatioMobile = ImageRatioEnum.r1_1;

  constructor() {
    this.imageHasBorder = this.sdLibConfig.get().productImageHasBorder;
    this.isSSR = isPlatformServer(this.platformId);
  }

  computedHostClasses = computed(() => {
    return [this.class(), this.isSSR ? 'is-ssr' : ''].filter(Boolean).join(' ');
  });

  ngOnInit() {
    if (!this.isSSR) {
      this.itemQty = Array(this.productInfo()?.maxQty || 6)
        .fill('')
        .map((x, i) => {
          return {
            value: i + 1
          };
        });

      this.subscription.add(
        this.deviceService.isMobile.subscribe((x) => {
          this.isMobile$ = x;
          this.cdRef.markForCheck();
        }),
      );
    }
  }

  ngAfterViewInit() {
    this.quantityForm = this.formBuilder.group({
      quantitySelector: { value: 1 }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  notifyQuantity() {
    if (this.quantitySelector()) {
      this.quantity.emit(this.quantitySelector().internalField.value);
    }
  }

  onClick(event?) {
    this.clicked.emit(event);
  }

  onOpenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }
}
